<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.5459 11.502C31.0585 2.66403 20.1565 -0.0143476 14.955 6.97185L12.582 7.08517C9.44872 7.23478 7.04674 10.0202 7.2589 13.2579L7.35546 14.7315C2.4729 16.9154 2.98295 24.601 8.46703 25.8421L9.16455 26H30.4632L30.7472 25.9332C36.6832 24.5374 37.8794 16.4383 32.8337 13.212L32.5459 11.502ZM30.3908 24.2956C32.7207 23.7477 33.958 21.8124 34.0921 19.7525C34.2237 17.7334 33.3007 15.56 31.2894 14.39L30.9565 11.8012L30.9551 11.7916C30.3204 8.02058 27.4518 5.69685 24.2281 5.09707C21.0425 4.5044 17.483 5.58894 15.3489 8.63411L12.6556 8.76272C10.419 8.86952 8.71927 10.8542 8.86932 13.144L9.01275 15.3328V15.9324C7.11492 16.5994 6.06039 18.3894 5.95013 20.1271C5.83614 21.9236 6.73298 23.7315 8.80986 24.2015L9.33772 24.321H30.2535L30.3908 24.2956Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1582 27.0258C11.4202 27.1131 11.5618 27.3963 11.4745 27.6582L10.4745 30.6582C10.3872 30.9202 10.104 31.0618 9.84202 30.9745C9.58005 30.8872 9.43847 30.604 9.52579 30.342L10.5258 27.342C10.6131 27.08 10.8963 26.9385 11.1582 27.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1582 32.0258C16.4202 32.1131 16.5618 32.3963 16.4745 32.6582L15.4745 35.6582C15.3872 35.9202 15.104 36.0618 14.842 35.9745C14.5801 35.8872 14.4385 35.604 14.5258 35.342L15.5258 32.342C15.6131 32.08 15.8963 31.9385 16.1582 32.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1582 27.0258C11.4202 27.1131 11.5618 27.3963 11.4745 27.6582L10.4745 30.6582C10.3872 30.9202 10.104 31.0618 9.84202 30.9745C9.58005 30.8872 9.43847 30.604 9.52579 30.342L10.5258 27.342C10.6131 27.08 10.8963 26.9385 11.1582 27.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.1582 32.0258C16.4202 32.1131 16.5618 32.3963 16.4745 32.6582L15.4745 35.6582C15.3872 35.9202 15.104 36.0618 14.842 35.9745C14.5801 35.8872 14.4385 35.604 14.5258 35.342L15.5258 32.342C15.6131 32.08 15.8963 31.9385 16.1582 32.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.1582 27.0258C15.4202 27.1131 15.5618 27.3963 15.4745 27.6582L14.4745 30.6582C14.3872 30.9202 14.104 31.0618 13.842 30.9745C13.5801 30.8872 13.4385 30.604 13.5258 30.342L14.5258 27.342C14.6131 27.08 14.8963 26.9385 15.1582 27.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1582 32.0258C20.4202 32.1131 20.5618 32.3963 20.4745 32.6582L19.4745 35.6582C19.3872 35.9202 19.104 36.0618 18.842 35.9745C18.5801 35.8872 18.4385 35.604 18.5258 35.342L19.5258 32.342C19.6131 32.08 19.8963 31.9385 20.1582 32.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1582 27.0258C19.4202 27.1131 19.5618 27.3963 19.4745 27.6582L18.4745 30.6582C18.3872 30.9202 18.104 31.0618 17.842 30.9745C17.5801 30.8872 17.4385 30.604 17.5258 30.342L18.5258 27.342C18.6131 27.08 18.8963 26.9385 19.1582 27.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.1582 32.0258C24.4202 32.1131 24.5618 32.3963 24.4745 32.6582L23.4745 35.6582C23.3872 35.9202 23.104 36.0618 22.842 35.9745C22.58 35.8872 22.4385 35.604 22.5258 35.342L23.5258 32.342C23.6131 32.08 23.8963 31.9385 24.1582 32.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1582 27.0258C23.4202 27.1131 23.5618 27.3963 23.4745 27.6582L22.4745 30.6582C22.3872 30.9202 22.104 31.0618 21.842 30.9745C21.58 30.8872 21.4385 30.604 21.5258 30.342L22.5258 27.342C22.6131 27.08 22.8963 26.9385 23.1582 27.0258Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.1582 27.0258C31.4202 27.1131 31.5618 27.3963 31.4745 27.6582L30.4745 30.6582C30.3872 30.9202 30.104 31.0618 29.842 30.9745C29.58 30.8872 29.4385 30.604 29.5258 30.342L30.5258 27.342C30.6131 27.08 30.8963 26.9385 31.1582 27.0258Z"
      class="fill-current"
    />
  </svg>
</template>
